<div class="picklist-verify lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large"
      >Verify Order# {{ currentPacking.orderNumber }}</span
    >
    <button
      (click)="onClearAll()"
      class="lum-button reset-button lum-button--secondary lum-button--large"
    >
      Reset
    </button>
  </div>

  <mat-dialog-content class="mat-typography">
    <div class="row">
      <div
        [ngClass]="{
          'col col-md-3': scanner.isStart,
          'd-none': !scanner.isStart,
        }"
      >
        <div class="qr-scanner mt-3">
          <div class="w-100 mb-4" *ngIf="scanner.isStart">
            <select
              [ngModel]="null"
              (ngModelChange)="onSelectDevice($event)"
              ngDefaultControl
              class="form-select form-select-sm"
            >
              <option [value]="null" selected>Select device</option>
              <option
                *ngFor="let device of scanner.devices.value; let i = index"
                [ngValue]="device.deviceId"
                [selected]="device.deviceId == selectedCameraDevice"
              >
                {{ device.label }}
              </option>
            </select>
          </div>
          <ngx-scanner-qrcode
            class="mb-4"
            #scanner
            [config]="scannerConfig"
            (event)="onQRScanChange($event)"
            [isBeep]="shouldBeep"
            [class]="{ 'qr-scanner-active': scanner.isStart }"
          ></ngx-scanner-qrcode>
          <ng-template *ngIf="scanner.isLoading">
            <mat-progress-spinner
              class="progress-spinner"
              diameter="16"
              mode="indeterminate"
            ></mat-progress-spinner>
          </ng-template>
        </div>
      </div>

      <div class="col">
        <div class="row mt-3 d-flex align-items-center">
          <div class="col-2">
            <lum-ui-input-button-group
              (click)="onAddQuantity()"
              label="Add Qty."
              [value]="scan.quantity"
              [disabledInput]="true"
            ></lum-ui-input-button-group>
          </div>
          <div class="col-6">
            <input
              type="text"
              autofocus="on"
              (keyup.enter)="onBarcodeScanChange($event)"
              (input)="onManualSearchChange($event)"
              class="lum-input lum-input--small"
              placeholder="Scan or enter product sku"
              [(ngModel)]="scan.sku"
              #searchInputRef
            />
          </div>
          <div class="col-4">
            <button
              (click)="onScan()"
              class="lum-button lum-button--primary lum-button--large"
              [disabled]="loadingScan"
            >
              <i class="fas fa-spinner fa-spin" *ngIf="loadingScan"></i> Verify Item
            </button>
          </div>
        </div>

        <div class="d-flex mt-4">
          <button
            (click)="scanner.isStart ? scanner.stop() : openScanner()"
            [title]="scanner.isStart ? 'Close' : 'Open Scanner'"
            class="lum-button lum-button--secondary lum-button--large mr-2"
          >
            <i class="fas fa-qrcode"></i>
          </button>
          <button
            (click)="onVerifyAll()"
            class="lum-button lum-button--primary lum-button--large"
          >
            Verify all
          </button>
        </div>

        <table class="lum-table lum-table--classic striped">
          <thead>
            <tr>
              <th width="10px">#</th>
              <th width="60%">Product Name</th>
              <th width="100px"></th>
              <th class="text-center" width="15%">Ordered Qty.</th>
              <th class="text-center" width="15%">Scanned</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="
                let item of currentPacking.items;
                let iItem = index;
                trackBy: trackByValue
              "
            >
              <tr
                [ngClass]="{
                  'bg-green-200 text-green-900':
                    item.baseUomQuantity === item.scanQuantity,
                  'bg-yellow-200 text-yellow-900': item.scanQuantity
                    ? item.baseUomQuantity > item.scanQuantity
                    : false,
                }"
              >
                <td class="align-middle">{{ iItem + 1 }}</td>
                <td class="product_name_cell flex gap-4">
                  <div
                    class="product_name text-ellipsis"
                    [matTooltip]="item.productName"
                  >
                    <ng-container *ngIf="item.type === eItemType.KIT">
                      <a
                        (click)="item.expanded = !item.expanded"
                        class="href-expand-detail"
                      >
                        [{{ item.sku }}] {{ item.productName }}
                      </a>
                    </ng-container>
                    <ng-container *ngIf="item.type === eItemType.PRODUCT">
                      [{{ item.sku }}] {{ item.productName }}
                    </ng-container>
                  </div>

                  <mat-chip
                    class="
                      lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small
                    "
                    >{{ item.type }}</mat-chip
                  >
                </td>
                <td class="align-middle">
                  <div class="d-flex" *ngIf="item.type === eItemType.PRODUCT">
                    <a (click)="onVerify(iItem)" class="href-expand-detail">
                      Verify
                    </a>
                    <span class="mx-3"> | </span>
                    <a (click)="onClear(iItem)" class="href-expand-detail">
                      Clear
                    </a>
                  </div>
                </td>
                <td class="align-middle text-center">
                  <span class="text-quantity my-5">{{
                    item.baseUomQuantity | decimalPlaces
                  }}</span>
                </td>
                <td
                  class="align-middle text-center"
                  [ngClass]="{
                    'bg-green-900 text-white':
                      item.baseUomQuantity === item.scanQuantity,
                  }"
                >
                  <span class="text-quantity my-5">{{
                    item.scanQuantity ? (item.scanQuantity | decimalPlaces) : 0
                  }}</span>
                </td>
              </tr>
              <tr *ngIf="item.expanded && item.type === eItemType.KIT">
                <td [attr.colspan]="5" class="text-gray-900 bg-gray-200 p-0 m-0">
                  <table class="lum-table lum-table--classic striped">
                    <tr class="text-cloud-900 bg-cloud-300">
                      <th width="10px"></th>
                      <th width="60%">Product Name</th>
                      <th width="100px"></th>
                      <th class="text-center" width="15%">Ordered Qty.</th>
                      <th class="text-center" width="15%">Scanned</th>
                    </tr>
                    <tr
                      *ngFor="let kitItem of item.kitItems; let iKitItem = index"
                      [ngClass]="{
                        'bg-green-200 text-green-900':
                          kitItem.baseUomQuantity * item.baseUomQuantity ===
                          kitItem.scanQuantity,
                        'bg-yellow-200 text-yellow-900': kitItem.scanQuantity
                          ? kitItem.baseUomQuantity * item.baseUomQuantity >
                            kitItem.scanQuantity
                          : false,
                        'bg-gray-200 text-gray-900':
                          item.baseUomQuantity !== item.scanQuantity,
                      }"
                    >
                      <td class="align-middle"></td>
                      <td class="product_name_cell flex gap-4">
                        <div
                          class="product_name text-ellipsis"
                          [matTooltip]="kitItem?.productName || ''"
                        >
                          [{{ kitItem?.sku }}] {{ kitItem?.productName }}
                        </div>
                        <mat-chip
                          class="
                            lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small text-center
                          "
                          >KIT COMPONENT</mat-chip
                        >
                      </td>
                      <td class="align-middle">
                        <div class="d-flex">
                          <a
                            (click)="onVerify(iItem, iKitItem)"
                            class="href-expand-detail"
                          >
                            Verify
                          </a>
                          <span class="mx-3"> | </span>
                          <a
                            (click)="onClear(iItem, iKitItem)"
                            class="href-expand-detail"
                          >
                            Clear
                          </a>
                        </div>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-quantity my-5">{{
                          kitItem.baseUomQuantity * item.baseUomQuantity
                            | decimalPlaces
                        }}</span>
                      </td>
                      <td
                        class="align-middle text-center"
                        [ngClass]="{
                          'bg-green-900 text-white':
                            kitItem.baseUomQuantity * item.baseUomQuantity ===
                            kitItem.scanQuantity,
                        }"
                      >
                        <span class="text-quantity my-5">{{
                          kitItem.scanQuantity
                            ? (kitItem.scanQuantity | decimalPlaces)
                            : 0
                        }}</span>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button (click)="onClose()" class="lum-button lum-button--secondary" mat-button>
      Cancel
    </button>
    <button
      (click)="onSubmit()"
      class="lum-button lum-button--primary"
      [disabled]="orderQty !== scanQuantity"
      mat-button
    >
      Done
    </button>
  </mat-dialog-actions>
</div>
